import { Header } from "@components/shared/header";
import { Aside } from "@components/shared/aside";
import { Footer } from "@components/shared/footer";
import { BackToTop } from "@components/ui/backToTop";
import { FraudBanner } from "@components/shared/fraud-banner";

interface PageLayoutProps {
    children: React.ReactNode;
    className?: string;
}

function PageLayout({ children, className }: PageLayoutProps) {
    return (
        <div className={className}>
            <FraudBanner />
            <BackToTop />
            <Header />
            <Aside />

            {/*
                The aside is `lg:fixed` and opaque, so it covers the first `asideWidth` of the
                viewport. From 2xl up each section clears it with its own `2xl:pl-*`; below that
                nothing did, which let content slide underneath. Reserve the gutter here instead,
                and hand it back at 2xl so the existing desktop offsets stay in charge.
            */}
            <main
                id="main-content"
                tabIndex={-1}
                className="scroll-mt-[56px] focus:outline-none lg:pl-asideWidth 2xl:pl-0"
            >
                {children}
            </main>

            <Footer />
        </div>
    );
}

export default PageLayout;
